import { FULL_HD, HD, RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import { FONT, getFont } from '@tornado-rdk/typography';
import { PRIMARY } from '@tornado-rdk/theme';
import { getElementSize } from '../utils/sizes';
import * as CUSTOMER from './customer/default/card.constants';

export * from './customer/default/card.constants';

export const ICON_PADDING_VERTICAL = 4;

export const ICON_PADDING_HORIZONTAL = 8;

export const ICON_HEIGHT = {
  [HD]: 24,
  [FULL_HD]: 32,
};

const RATIO = 9 / 16;

const metadataHeight = {
  [HD]:
    CUSTOMER.INCENTIVE_HEIGHT[HD] +
    getFont(CUSTOMER.EXTRA_TITLE_FONT_NAME, HD, CUSTOMER.EXTRA_TITLE_FONT_TYPE).lineHeight *
      CUSTOMER.EXTRA_TITLE_LINES +
    getFont(CUSTOMER.TITLE_FONT_NAME, HD, CUSTOMER.TITLE_FONT_TYPE).lineHeight +
    getFont(FONT.BERLIN_1, HD).lineHeight +
    CUSTOMER.IMAGE_MARGIN_BOTTOM,
  [FULL_HD]:
    CUSTOMER.INCENTIVE_HEIGHT[FULL_HD] +
    getFont(CUSTOMER.EXTRA_TITLE_FONT_NAME, FULL_HD, CUSTOMER.EXTRA_TITLE_FONT_TYPE).lineHeight *
      CUSTOMER.EXTRA_TITLE_LINES +
    getFont(CUSTOMER.TITLE_FONT_NAME, FULL_HD, CUSTOMER.TITLE_FONT_TYPE).lineHeight +
    getFont(FONT.BERLIN_1, FULL_HD).lineHeight +
    CUSTOMER.IMAGE_MARGIN_BOTTOM,
};

export const imageOptions = [CUSTOMER.templates.CardS, CUSTOMER.templates.CardM, CUSTOMER.templates.CardL].reduce(
  (result, template) => {
    const { imageOptions: templateImageOptions } = getElementSize(
      CUSTOMER.ITEMS_BY_BREAKPOINTS[template],
      RATIO,
      template,
    );

    return {
      ...result,
      ...templateImageOptions,
    };
  },
  {},
);

const buildSizes = (template, context) => ({
  [HD]: {
    w: imageOptions[template][context][HD][PRIMARY].width,
    h: imageOptions[template][context][HD][PRIMARY].height + metadataHeight[HD],
  },
  [FULL_HD]: {
    w: imageOptions[template][context][FULL_HD][PRIMARY].width,
    h: imageOptions[template][context][FULL_HD][PRIMARY].height + metadataHeight[FULL_HD],
  },
});

export const sizes = [CUSTOMER.templates.CardS, CUSTOMER.templates.CardM, CUSTOMER.templates.CardL].reduce(
  (result, template) => ({
    ...result,
    [template]: {
      [RENDERING_CONTEXT.GENERAL]: buildSizes(template, RENDERING_CONTEXT.GENERAL),
      [RENDERING_CONTEXT.SEARCH]: buildSizes(template, RENDERING_CONTEXT.SEARCH),
    },
  }),
  {},
);
